import { render, staticRenderFns } from "./CampanhaPieChartCustom.vue?vue&type=template&id=399ae82e&scoped=true&"
import script from "./CampanhaPieChartCustom.vue?vue&type=script&lang=js&"
export * from "./CampanhaPieChartCustom.vue?vue&type=script&lang=js&"
import style0 from "./CampanhaPieChartCustom.vue?vue&type=style&index=0&id=399ae82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ae82e",
  null
  
)

export default component.exports